var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79296 5.958V8.706C5.44687 8.61473 5.08471 8.60229 4.73317 8.6696C4.38164 8.73691 4.04969 8.88225 3.76179 9.09491C3.47389 9.30757 3.23739 9.58212 3.06971 9.89834C2.90204 10.2146 2.80746 10.5644 2.79296 10.922C2.77261 11.2303 2.81856 11.5395 2.92771 11.8285C3.03687 12.1176 3.2067 12.38 3.42578 12.5979C3.64485 12.8158 3.90807 12.9843 4.19772 13.092C4.48737 13.1996 4.79673 13.244 5.10496 13.222C5.41577 13.2456 5.72801 13.2015 6.02013 13.0928C6.31225 12.984 6.5773 12.8132 6.79699 12.5921C7.01669 12.371 7.1858 12.1048 7.29266 11.812C7.39952 11.5192 7.44159 11.2067 7.41596 10.896V0H10.135C10.598 2.876 12.035 3.544 13.962 3.852V6.608C12.6273 6.49893 11.3397 6.06424 10.212 5.342V10.787C10.21 13.25 8.74996 16 5.12496 16C4.44502 15.9969 3.77253 15.8581 3.14691 15.5918C2.52128 15.3255 1.9551 14.937 1.48152 14.4491C1.00795 13.9612 0.636516 13.3836 0.388981 12.7503C0.141446 12.1171 0.0227879 11.4407 0.0399601 10.761C0.0613404 10.0531 0.232544 9.35787 0.54228 8.72102C0.852015 8.08418 1.29324 7.52023 1.83687 7.06637C2.38049 6.61252 3.01416 6.27907 3.69608 6.08802C4.37799 5.89697 5.09267 5.85265 5.79296 5.958V5.958Z",
    fill: "#33354E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.cf98af01a05cf13e30f482e19b3ae18e.svg";
export { ForwardRef as ReactComponent };